
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TPay } from '@/dto/Pays.dto';

@Component
export default class ToolTip extends Vue {
  @Prop() row!: TPay;
}
